module.exports = __webpack_public_path__ + "img/astral_18.b5d6c93e.svg";